module.exports = __webpack_public_path__ + "img/signLottery.6b043ea6.gif";